"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectSelectField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var icons_1 = require("@material-ui/icons");
var react_query_1 = require("react-query");
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var GraphQLClient_1 = require("../../GraphQLClient");
var ControlledSelectField_1 = require("../ControlledSelectField");
var styles_1 = __importDefault(require("./styles"));
exports.ProjectSelectField = react_1.default.memo(function (_a) {
    var selectedProjectId = _a.selectedProjectId, rest = __rest(_a, ["selectedProjectId"]);
    var _b = (0, react_1.useState)(1), page = _b[0], setPageNumber = _b[1];
    var _c = (0, react_1.useState)([]), projects = _c[0], setProjects = _c[1];
    var projectsSearchKey = react_common_lib_1.projectQueries.projectsSearchKey, searchProjects = react_common_lib_1.projectQueries.searchProjects;
    var client = (0, GraphQLClient_1.useGraphQLClient)();
    var queryProjects = (0, react_1.useCallback)(function () {
        return client.request(searchProjects, {
            direction: 'DESC',
            filter: { status: { contains: ['Open'] } },
            limit: 1000,
            page: page,
            sortBy: 'NUMBER',
            term: '',
        }, {});
    }, [client, page, searchProjects]);
    var _d = (0, react_query_1.useQuery)([projectsSearchKey, page], queryProjects, {
        refetchOnWindowFocus: false,
        onSuccess: function (data) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var projectsData = (_b = (_a = data === null || data === void 0 ? void 0 : data.searchProjects) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.map(function (p) { return ({
                id: p.document.id,
                name: p.document.name,
            }); });
            setProjects(function (prev) { return __spreadArray(__spreadArray([], prev, true), projectsData, true); });
            if (((_d = (_c = data === null || data === void 0 ? void 0 : data.searchProjects) === null || _c === void 0 ? void 0 : _c.pagination) === null || _d === void 0 ? void 0 : _d.currentPage) !==
                ((_f = (_e = data === null || data === void 0 ? void 0 : data.searchProjects) === null || _e === void 0 ? void 0 : _e.pagination) === null || _f === void 0 ? void 0 : _f.pages)) {
                var nextPage = Number((_h = (_g = data === null || data === void 0 ? void 0 : data.searchProjects) === null || _g === void 0 ? void 0 : _g.pagination) === null || _h === void 0 ? void 0 : _h.currentPage) + 1;
                setPageNumber(nextPage);
            }
            return data;
        },
    }), error = _d.error, isLoading = _d.isLoading;
    // TODO: Figure out why the storybook MenuItem is not working.
    var classes = (0, styles_1.default)();
    return ((0, jsx_runtime_1.jsx)(ControlledSelectField_1.ControlledSelectField, __assign({ helperText: error ? 'Unable to retrieve projects' : '', value: selectedProjectId, disabled: isLoading, SelectProps: {
            IconComponent: isLoading ? icons_1.Autorenew : icons_1.ArrowDropDown,
        }, select: true }, rest, { children: projects.map(function (project) { return ((0, jsx_runtime_1.jsx)(MenuItem_1.default, __assign({ className: classes.root, value: project.id }, { children: project.name }), project.id)); }) })));
});
